// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: ckZSvpXSdAvL
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import UploadDebtorsButton from "../../UploadDebtorsButton"; // plasmic-import: MdJmc5Uyku6A/component
import WebPortalButton from "../../WebPortalButton"; // plasmic-import: 8nAON6P7zEMx/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDebtorSubmission.module.css"; // plasmic-import: ckZSvpXSdAvL/css
import alertCircleDtTSsBsvQtbO from "./images/alertCircle.svg"; // plasmic-import: DtTSsBSVQtbO/picture
import alertCircle2Cr2MCsKzAzUt from "./images/alertCircle2.svg"; // plasmic-import: CR2mCsKzAZUt/picture
import alertCircle3YPnKrYDoizwQ from "./images/alertCircle3.svg"; // plasmic-import: YPnKrYDoizwQ/picture

createPlasmicElementProxy;

export const PlasmicDebtorSubmission__VariantProps = new Array();

export const PlasmicDebtorSubmission__ArgProps = new Array();

const $$ = {};

function PlasmicDebtorSubmission__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__xr0DM)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__wmEDj)}>
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"How do you want to submit your debtors?"}
                  </div>
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___0ZmUx)}
                >
                  <UploadDebtorsButton
                    data-plasmic-name={"uploadDebtorsButton"}
                    data-plasmic-override={overrides.uploadDebtorsButton}
                    className={classNames(
                      "__wab_instance",
                      sty.uploadDebtorsButton
                    )}
                  />

                  <WebPortalButton
                    data-plasmic-name={"webPortalButton"}
                    data-plasmic-override={overrides.webPortalButton}
                    className={classNames(
                      "__wab_instance",
                      sty.webPortalButton
                    )}
                  />
                </div>
              </Stack__>
            </div>
            <Stack__
              as={"div"}
              data-plasmic-name={"content"}
              data-plasmic-override={overrides.content}
              hasGap={true}
              className={classNames(projectcss.all, sty.content)}
            >
              <Stack__
                as={"div"}
                data-plasmic-name={"checkboxGroup"}
                data-plasmic-override={overrides.checkboxGroup}
                hasGap={true}
                className={classNames(projectcss.all, sty.checkboxGroup)}
              >
                {false ? (
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"checkboxGroupItem3"}
                    data-plasmic-override={overrides.checkboxGroupItem3}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.checkboxGroupItem3
                    )}
                  >
                    <Stack__
                      as={"div"}
                      data-plasmic-name={"content4"}
                      data-plasmic-override={overrides.content4}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.content4)}
                    >
                      <div
                        data-plasmic-name={"featuredIcon3"}
                        data-plasmic-override={overrides.featuredIcon3}
                        className={classNames(
                          projectcss.all,
                          sty.featuredIcon3
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__osmok)}
                          displayHeight={"16px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"16px"}
                          loading={"lazy"}
                          src={{
                            src: alertCircleDtTSsBsvQtbO,
                            fullWidth: 16,
                            fullHeight: 16,
                            aspectRatio: 1
                          }}
                        />
                      </div>
                      <div
                        data-plasmic-name={"textAndSupportingText3"}
                        data-plasmic-override={overrides.textAndSupportingText3}
                        className={classNames(
                          projectcss.all,
                          sty.textAndSupportingText3
                        )}
                      >
                        <Stack__
                          as={"div"}
                          data-plasmic-name={"textAndSubtext3"}
                          data-plasmic-override={overrides.textAndSubtext3}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.textAndSubtext3
                          )}
                        >
                          <div
                            data-plasmic-name={"text3"}
                            data-plasmic-override={overrides.text3}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text3
                            )}
                          >
                            {"Enterprise plan"}
                          </div>
                          <div
                            data-plasmic-name={"subtext3"}
                            data-plasmic-override={overrides.subtext3}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.subtext3
                            )}
                          >
                            {"$40/month"}
                          </div>
                        </Stack__>
                        <div
                          data-plasmic-name={
                            "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5"
                          }
                          data-plasmic-override={
                            overrides.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5
                          }
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5
                          )}
                        >
                          {"Unlimited users and unlimited individual data."}
                        </div>
                      </div>
                    </Stack__>
                    <div
                      data-plasmic-name={"checkboxBase3"}
                      data-plasmic-override={overrides.checkboxBase3}
                      className={classNames(projectcss.all, sty.checkboxBase3)}
                    />
                  </Stack__>
                ) : null}
                {false ? (
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"checkboxGroupItem4"}
                    data-plasmic-override={overrides.checkboxGroupItem4}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.checkboxGroupItem4
                    )}
                  >
                    <Stack__
                      as={"div"}
                      data-plasmic-name={"content5"}
                      data-plasmic-override={overrides.content5}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.content5)}
                    >
                      <div
                        data-plasmic-name={"featuredIcon4"}
                        data-plasmic-override={overrides.featuredIcon4}
                        className={classNames(
                          projectcss.all,
                          sty.featuredIcon4
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__e8Fzx)}
                          displayHeight={"16px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"16px"}
                          loading={"lazy"}
                          src={{
                            src: alertCircle2Cr2MCsKzAzUt,
                            fullWidth: 16,
                            fullHeight: 16,
                            aspectRatio: 1
                          }}
                        />
                      </div>
                      <div
                        data-plasmic-name={"textAndSupportingText4"}
                        data-plasmic-override={overrides.textAndSupportingText4}
                        className={classNames(
                          projectcss.all,
                          sty.textAndSupportingText4
                        )}
                      >
                        <Stack__
                          as={"div"}
                          data-plasmic-name={"textAndSubtext4"}
                          data-plasmic-override={overrides.textAndSubtext4}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.textAndSubtext4
                          )}
                        >
                          <div
                            data-plasmic-name={"text4"}
                            data-plasmic-override={overrides.text4}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text4
                            )}
                          >
                            {"Ultimate plan"}
                          </div>
                          <div
                            data-plasmic-name={"subtext4"}
                            data-plasmic-override={overrides.subtext4}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.subtext4
                            )}
                          >
                            {"$60/month"}
                          </div>
                        </Stack__>
                        <div
                          data-plasmic-name={
                            "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6"
                          }
                          data-plasmic-override={
                            overrides.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6
                          }
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6
                          )}
                        >
                          {"Unlimited users and unlimited indiviual data."}
                        </div>
                      </div>
                    </Stack__>
                    <div
                      data-plasmic-name={"checkboxBase4"}
                      data-plasmic-override={overrides.checkboxBase4}
                      className={classNames(projectcss.all, sty.checkboxBase4)}
                    />
                  </Stack__>
                ) : null}
                {false ? (
                  <Stack__
                    as={"div"}
                    data-plasmic-name={"checkboxGroupItem5"}
                    data-plasmic-override={overrides.checkboxGroupItem5}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      sty.checkboxGroupItem5
                    )}
                  >
                    <Stack__
                      as={"div"}
                      data-plasmic-name={"content6"}
                      data-plasmic-override={overrides.content6}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.content6)}
                    >
                      <div
                        data-plasmic-name={"featuredIcon5"}
                        data-plasmic-override={overrides.featuredIcon5}
                        className={classNames(
                          projectcss.all,
                          sty.featuredIcon5
                        )}
                      >
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__zvJk)}
                          displayHeight={"16px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"16px"}
                          loading={"lazy"}
                          src={{
                            src: alertCircle3YPnKrYDoizwQ,
                            fullWidth: 16,
                            fullHeight: 16,
                            aspectRatio: 1
                          }}
                        />
                      </div>
                      <div
                        data-plasmic-name={"textAndSupportingText5"}
                        data-plasmic-override={overrides.textAndSupportingText5}
                        className={classNames(
                          projectcss.all,
                          sty.textAndSupportingText5
                        )}
                      >
                        <Stack__
                          as={"div"}
                          data-plasmic-name={"textAndSubtext5"}
                          data-plasmic-override={overrides.textAndSubtext5}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.textAndSubtext5
                          )}
                        >
                          <div
                            data-plasmic-name={"text5"}
                            data-plasmic-override={overrides.text5}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text5
                            )}
                          >
                            {"Secret plan"}
                          </div>
                          <div
                            data-plasmic-name={"subtext5"}
                            data-plasmic-override={overrides.subtext5}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.subtext5
                            )}
                          >
                            {"$80/month"}
                          </div>
                        </Stack__>
                        <div
                          data-plasmic-name={
                            "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7"
                          }
                          data-plasmic-override={
                            overrides.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7
                          }
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7
                          )}
                        >
                          {"Unlimited users and unlimited indiviual data."}
                        </div>
                      </div>
                    </Stack__>
                    <div
                      data-plasmic-name={"checkboxBase5"}
                      data-plasmic-override={overrides.checkboxBase5}
                      className={classNames(projectcss.all, sty.checkboxBase5)}
                    />
                  </Stack__>
                ) : null}
              </Stack__>
            </Stack__>
            <div
              data-plasmic-name={"errorText"}
              data-plasmic-override={overrides.errorText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.errorText
              )}
            >
              {"Please select an option"}
            </div>
            <div
              data-plasmic-name={"continueButton"}
              data-plasmic-override={overrides.continueButton}
              className={classNames(projectcss.all, sty.continueButton)}
            >
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {hasVariant(globalVariants, "screen", "medium")
                  ? "Continue"
                  : "Continue"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "invoiceDetails",
    "title4",
    "uploadDebtorsButton",
    "webPortalButton",
    "content",
    "checkboxGroup",
    "checkboxGroupItem3",
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5",
    "checkboxBase3",
    "checkboxGroupItem4",
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6",
    "checkboxBase4",
    "checkboxGroupItem5",
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7",
    "checkboxBase5",
    "errorText",
    "continueButton",
    "text"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "invoiceDetails",
    "title4",
    "uploadDebtorsButton",
    "webPortalButton",
    "content",
    "checkboxGroup",
    "checkboxGroupItem3",
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5",
    "checkboxBase3",
    "checkboxGroupItem4",
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6",
    "checkboxBase4",
    "checkboxGroupItem5",
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7",
    "checkboxBase5",
    "errorText",
    "continueButton",
    "text"
  ],

  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "uploadDebtorsButton",
    "webPortalButton"
  ],

  title4: ["title4"],
  uploadDebtorsButton: ["uploadDebtorsButton"],
  webPortalButton: ["webPortalButton"],
  content: [
    "content",
    "checkboxGroup",
    "checkboxGroupItem3",
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5",
    "checkboxBase3",
    "checkboxGroupItem4",
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6",
    "checkboxBase4",
    "checkboxGroupItem5",
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7",
    "checkboxBase5"
  ],

  checkboxGroup: [
    "checkboxGroup",
    "checkboxGroupItem3",
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5",
    "checkboxBase3",
    "checkboxGroupItem4",
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6",
    "checkboxBase4",
    "checkboxGroupItem5",
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7",
    "checkboxBase5"
  ],

  checkboxGroupItem3: [
    "checkboxGroupItem3",
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5",
    "checkboxBase3"
  ],

  content4: [
    "content4",
    "featuredIcon3",
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5"
  ],

  featuredIcon3: ["featuredIcon3"],
  textAndSupportingText3: [
    "textAndSupportingText3",
    "textAndSubtext3",
    "text3",
    "subtext3",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5"
  ],

  textAndSubtext3: ["textAndSubtext3", "text3", "subtext3"],
  text3: ["text3"],
  subtext3: ["subtext3"],
  includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5: [
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5"
  ],

  checkboxBase3: ["checkboxBase3"],
  checkboxGroupItem4: [
    "checkboxGroupItem4",
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6",
    "checkboxBase4"
  ],

  content5: [
    "content5",
    "featuredIcon4",
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6"
  ],

  featuredIcon4: ["featuredIcon4"],
  textAndSupportingText4: [
    "textAndSupportingText4",
    "textAndSubtext4",
    "text4",
    "subtext4",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6"
  ],

  textAndSubtext4: ["textAndSubtext4", "text4", "subtext4"],
  text4: ["text4"],
  subtext4: ["subtext4"],
  includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6: [
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6"
  ],

  checkboxBase4: ["checkboxBase4"],
  checkboxGroupItem5: [
    "checkboxGroupItem5",
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7",
    "checkboxBase5"
  ],

  content6: [
    "content6",
    "featuredIcon5",
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7"
  ],

  featuredIcon5: ["featuredIcon5"],
  textAndSupportingText5: [
    "textAndSupportingText5",
    "textAndSubtext5",
    "text5",
    "subtext5",
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7"
  ],

  textAndSubtext5: ["textAndSubtext5", "text5", "subtext5"],
  text5: ["text5"],
  subtext5: ["subtext5"],
  includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7: [
    "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7"
  ],

  checkboxBase5: ["checkboxBase5"],
  errorText: ["errorText"],
  continueButton: ["continueButton", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDebtorSubmission__ArgProps,
          internalVariantPropNames: PlasmicDebtorSubmission__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDebtorSubmission__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDebtorSubmission";
  } else {
    func.displayName = `PlasmicDebtorSubmission.${nodeName}`;
  }
  return func;
}

export const PlasmicDebtorSubmission = Object.assign(
  // Top-level PlasmicDebtorSubmission renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    uploadDebtorsButton: makeNodeComponent("uploadDebtorsButton"),
    webPortalButton: makeNodeComponent("webPortalButton"),
    content: makeNodeComponent("content"),
    checkboxGroup: makeNodeComponent("checkboxGroup"),
    checkboxGroupItem3: makeNodeComponent("checkboxGroupItem3"),
    content4: makeNodeComponent("content4"),
    featuredIcon3: makeNodeComponent("featuredIcon3"),
    textAndSupportingText3: makeNodeComponent("textAndSupportingText3"),
    textAndSubtext3: makeNodeComponent("textAndSubtext3"),
    text3: makeNodeComponent("text3"),
    subtext3: makeNodeComponent("subtext3"),
    includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5:
      makeNodeComponent(
        "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures5"
      ),
    checkboxBase3: makeNodeComponent("checkboxBase3"),
    checkboxGroupItem4: makeNodeComponent("checkboxGroupItem4"),
    content5: makeNodeComponent("content5"),
    featuredIcon4: makeNodeComponent("featuredIcon4"),
    textAndSupportingText4: makeNodeComponent("textAndSupportingText4"),
    textAndSubtext4: makeNodeComponent("textAndSubtext4"),
    text4: makeNodeComponent("text4"),
    subtext4: makeNodeComponent("subtext4"),
    includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6:
      makeNodeComponent(
        "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures6"
      ),
    checkboxBase4: makeNodeComponent("checkboxBase4"),
    checkboxGroupItem5: makeNodeComponent("checkboxGroupItem5"),
    content6: makeNodeComponent("content6"),
    featuredIcon5: makeNodeComponent("featuredIcon5"),
    textAndSupportingText5: makeNodeComponent("textAndSupportingText5"),
    textAndSubtext5: makeNodeComponent("textAndSubtext5"),
    text5: makeNodeComponent("text5"),
    subtext5: makeNodeComponent("subtext5"),
    includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7:
      makeNodeComponent(
        "includesUpTo10Users20GbIndividualDataAndAccessToAllFeatures7"
      ),
    checkboxBase5: makeNodeComponent("checkboxBase5"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicDebtorSubmission
    internalVariantProps: PlasmicDebtorSubmission__VariantProps,
    internalArgProps: PlasmicDebtorSubmission__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDebtorSubmission;
/* prettier-ignore-end */
